import { CommunityUtil } from '../../../administrator/communities/utils/CommunityUtil';
import { GuestDTO } from '../dtos/Guest.dto';
import { GuestModel } from '../models/Guest.model';

export class GuestUtil {
  public static mapToViewModel(dto: GuestDTO): GuestModel {
    return {
      id: dto.id,
      community:
        typeof dto.community === 'string'
          ? dto.community
          : CommunityUtil.mapToViewModel(dto.community),
      isDeleted: dto.deleted,
      createdOn: dto.createdOn ? dto.createdOn : null,
      lastLogin: dto.lastLogin ? dto.lastLogin : null,
    };
  }
}
